// 认证工具函数

// 设置用户登录状态
export function setUserLogin(token, userInfo) {
  localStorage.setItem('userToken', token);
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
  localStorage.setItem('loginType', userInfo.loginType || 'traditional');
}

// 清除用户登录状态
export function clearUserLogin() {
  localStorage.removeItem('userToken');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('loginType');
}

// 检查用户是否已登录
export function isUserLoggedIn() {
  const token = localStorage.getItem('userToken');
  const userInfo = localStorage.getItem('userInfo');

  // 如果有token和用户信息，认为已登录
  return !!(token && userInfo);
}

// 获取用户信息
export function getUserInfo() {
  const userInfo = localStorage.getItem('userInfo');
  return userInfo ? JSON.parse(userInfo) : null;
}

// 更新本地用户信息
export function updateUserInfo(updates) {
  const userInfo = {
    ...(getUserInfo() || {}),
    ...updates,
  };

  localStorage.setItem('userInfo', JSON.stringify(userInfo));
  return userInfo;
}

// 获取用户token
export function getUserToken() {
  return localStorage.getItem('userToken');
}

// 获取登录类型
export function getLoginType() {
  return localStorage.getItem('loginType') || 'traditional';
}

// 检查是否是企业微信登录
export function isWeComLogin() {
  return getLoginType() === 'wecom';
}

// 模拟登录（用于测试）
export function mockLogin() {
  const mockUserInfo = {
    id: 1,
    username: 'admin',
    email: 'admin@example.com',
    role: 'admin'
  };
  const mockToken = 'mock-jwt-token-' + Date.now();

  setUserLogin(mockToken, mockUserInfo);
  return { token: mockToken, userInfo: mockUserInfo };
}

// 模拟登出
export function mockLogout() {
  clearUserLogin();
}
